import clsx from 'clsx'
import { ReactNode } from 'react'
import { ClassName } from 'types/props'

import classes from './index.module.scss'

export interface AlertProps extends ClassName {
  children: ReactNode
  title?: string
  type: 'success' | 'warning' | 'error' | 'information'
}

export const Alert = ({ children, className, title, type }: AlertProps) => (
  <div className={clsx(className, classes.root, classes[type])}>
    {title && <h6>{title}</h6>}
    {children}
  </div>
)
